import { Injectable } from '@angular/core';
import { Collection, CollectionConfig } from '@cardium/core-client/collection';
import { IUser } from '@cardium/contracts';

@Injectable()
export class UserCollection extends Collection<IUser> {
  protected config: CollectionConfig = {
    apiUrl: 'api/core/user/User',
    endpoints: {
      list: () => `${this.config.apiUrl}/user-list.query`,
      one: (id) => `${this.config.apiUrl}/user.query?[id]=${id}`,
      create: () => `${this.config.apiUrl}/user-save.command`,
      update: () => `${this.config.apiUrl}/user-save.command`,
    },
  };
}
